import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import {
  SharingCollaboratorResponse,
  SharingDebitProjectExpenseCollaboratorRequest,
  SharingDebitProjectExpenseCollaboratorResponse,
  SharingDebitProjectExpenseResponse,
  SharingDebitProjectResponse,
  SharingDetailsCollaboratorRequest,
  SharingDetailsRequest,
  SharinSingleCollaboratorDetailsResponse,
  SharinSingleCollaboratorExpenseResponse,
} from '../models/sharingDetails';

/**
 * <p>
 * API endpoints that cover all resource project related CRUD calls
 */

export const sharingDetail = api.injectEndpoints({
  endpoints: (builder) => ({
    // GET
    FindAllGroupedByDebitProject: builder.query<PaginationResponse<SharingDebitProjectResponse>, SharingDetailsRequest>(
      {
        query: (input) => ({
          url: encodeURI(
            `/salary/sharing-result/findAllGroupedByDebitProject?period=${input.data}&searchTerm=${input.searchTerm}&page=${input.page}&size=${input.size}`,
          ),
          method: 'GET',
        }),
        providesTags: ['FindAllGroupedByDebitProject'],
      },
    ),
    FindAllDebitProjectAndExpense: builder.query<
      PaginationResponse<SharingDebitProjectExpenseResponse>,
      SharingDetailsRequest
    >({
      query: (input) => ({
        url: encodeURI(
          `/salary/sharing-result/findAllGroupedByDebitProjectAndExpense?period=${input.data}&searchTerm=${input.searchTerm}&page=${input.page}&size=${input.size}`,
        ),
        method: 'GET',
      }),
      providesTags: ['FindAllGroupedByDebitProject'],
    }),
    FindAllCollaboratorProject: builder.query<SharingCollaboratorResponse[], SharingDetailsCollaboratorRequest>({
      query: (input) => ({
        url: encodeURI(
          `/salary/sharing-result-detail/findAllGroupedByProject?period=${input.data}&projectCode=${input.searchTerm}`,
        ),
        method: 'GET',
      }),
      providesTags: ['FindAllGroupedByDebitProject'],
    }),
    FindAllCollaboratorProjectExpense: builder.query<
      SharingDebitProjectExpenseCollaboratorResponse[],
      SharingDebitProjectExpenseCollaboratorRequest
    >({
      query: (input) => ({
        url: encodeURI(
          `/salary/sharing-result/findAllGroupedByDebitProjectAndPersonAndExpense?period=${input.data}&badge=${input.badge}&debitProjectCode=${input.code}`,
        ),
        method: 'GET',
      }),
      providesTags: ['FindAllGroupedByDebitProject'],
    }),
    FindSingleCollaboratorProject: builder.query<
      SharinSingleCollaboratorDetailsResponse,
      SharingDebitProjectExpenseCollaboratorRequest
    >({
      query: (input) => ({
        url: encodeURI(
          `/salary/sharing-result-detail/findAllGroupedForSinglePerson?period=${input.data}&projectCode=${input.badge}&badge=${input.code}`,
        ),
        method: 'GET',
      }),
      providesTags: ['FindAllGroupedByDebitProject'],
    }),
    FindSingleCollaboratorAndExpenseProject: builder.query<
      SharinSingleCollaboratorExpenseResponse[],
      SharingDebitProjectExpenseCollaboratorRequest
    >({
      query: (input) => ({
        url: encodeURI(
          `/salary/sharing-result-detail/findByPeriodAndProjectAndPerson?period=${input.data}&projectCode=${input.code}&badge=${input.badge}`,
        ),
        method: 'GET',
      }),
      providesTags: ['FindAllGroupedByDebitProject'],
    }),
  }),
});

export const {
  useFindAllGroupedByDebitProjectQuery,
  useFindAllDebitProjectAndExpenseQuery,
  useFindAllCollaboratorProjectQuery,
  useFindAllCollaboratorProjectExpenseQuery,
  useFindSingleCollaboratorProjectQuery,
  useFindSingleCollaboratorAndExpenseProjectQuery,
} = sharingDetail;
